import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewEventsSummaryModule"
const debug = false

export class ViewEventsSummaryModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_EVENTS_SUMMARY, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "Events summary"
        this.description             = ""
        this.svgIcon                 = "isvg-view-events-summary"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Views            "
        this.settingsUrl             = "settings/view-events-summary"
        this.parentSection              = SettingsParentSection.VIEWS

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}